import React from "react"
import queryString from "query-string"
import PrivateRoute from "../../_helpers/privateRoute.js"
import Accounts from "./accounts/accounts"
import Metrics from "./metrics/metrics.js"
import Overview from "./overview.js"
import Ads from "./ads/ads.js"
import Audience from "./audience/audience.js"
import Placement from "./placement/placement.js"
import PlacementSection from "./placement/placementSection.js"
import Budget from "./budget/budget.js"
import Publish from "./publish/publish.js"
import "../../style/styles.css"

class CampaignHome extends React.Component {

    state = {
        active: "overview"
    };

    componentWillMount(){
        let params = queryString.parse(this.props.location.search);
        let pathname = this.props.location.pathname;
        let tab = pathname.slice(pathname.lastIndexOf('/') + 1);
        tab = tab === "campaignGroup" ? "overview" : tab;

        this.setState({active: tab});

        if (params) {
            let clientId = params.client_id;
            let campaignId = params.campaign_id;
            let clientName = params.client_name;
            this.data = {};
            this.data.pageTitle = "Add Campaign";
            if (clientId) {
                this.data.clientId = clientId;
            }
            if(campaignId) {   
                this.data.campaignId = campaignId;
                this.data.pageTitle = "Edit Campaign";
            }
            if (clientName) {
                this.data.clientName = clientName;
            }
        }  
    }

    onNavClick = (value) => {
        this.setState({active: value});
        var queryString = '';
        if (this.data.clientId && this.data.campaignId) {
            queryString = '?client_id=' + this.data.clientId + '&campaign_id=' + this.data.campaignId;
        } else {
            queryString = '?client_id=' + this.data.clientId;
        }
        if (this.data.clientName) {
            queryString += '&client_name=' + this.data.clientName;
        }
        switch(value) {
            case "audience":
                this.props.history.push("/campaignGroup/audience" + queryString);
                return;
            case "accounts":
                this.props.history.push("/campaignGroup/accounts" + queryString);
                return;
            case "metrics":
                this.props.history.push("/campaignGroup/metrics" + queryString);
                return;
            case "placement":
                this.props.history.push("/campaignGroup/placement" + queryString);
                return;
            case "ads" : 
                this.props.history.push("/campaignGroup/ads" + queryString);
                return;
            case "budget":
                this.props.history.push("/campaignGroup/budget" + queryString);
                return;
            case "publish":
                this.props.history.push("/campaignGroup/publish" + queryString);
                return;
            default: this.props.history.push("/campaignGroup/overview" + queryString);
        }
    };

    render() {
        return (

        <div className="page-main">
            <div className="page-content">
                <div>
                    <div className="nav">
                        <ul className="nav-links">
                            <li
                                onClick={ () => this.onNavClick("overview")}
                                className={this.state.active === "overview" ? "selected nav-item" : "nav-item"}
                            >
                                Overview and Setup
                            </li>
                            <li
                                onClick={ () => this.onNavClick("audience")}
                                className={this.state.active === "audience" ? "selected nav-item" : "nav-item"}
                            >
                                Audience
                            </li>
                            <li
                                onClick={ () => this.onNavClick("placement")}
                                className={this.state.active === "placement" ? "selected nav-item" : "nav-item"}
                            >
                                Placement
                            </li>
                            <li
                                onClick={ () => this.onNavClick("accounts")}
                                className={this.state.active === "accounts" ? "selected nav-item" : "nav-item"}
                            >
                                Accounts
                            </li>
                            <li
                                onClick={ () => this.onNavClick("metrics")}
                                className={this.state.active === "metrics" ? "selected nav-item" : "nav-item"}
                            >
                                Metrics
                            </li>
                            <li
                                onClick={ () => this.onNavClick("ads")}
                                className={this.state.active === "ads" ? "selected nav-item" : "nav-item"}
                            >
                                Ads and Creative
                            </li>
                            <li
                                onClick={ () => this.onNavClick("budget")}
                                className={this.state.active === "budget" ? "selected nav-item" : "nav-item"}
                            >
                                Budget and Conversion Tracking
                            </li>
                            <li
                                onClick={ () => this.onNavClick("publish")}
                                className={this.state.active === "publish" ? "selected nav-item" : "nav-item"}
                            >
                                Publish
                            </li>
                        </ul>
                    </div>
                    <div className="main-component">
                        <PrivateRoute
                            exact
                            path = {["/campaignGroup", "/campaignGroup/overview"]}
                            data = {this.data}
                            component = {Overview}
                        />
                        <PrivateRoute
                            path="/campaignGroup/audience"
                            data = {this.data}
                            updateState = {this.updateState}
                            component={Audience}
                         />
                         <PrivateRoute
                            path="/campaignGroup/placement"
                            data = {this.data}
                            updateState = {this.updateState}
                            component={Placement}
                        />
                        <PrivateRoute
                            path="/campaignGroup/accounts"
                            data = {this.data}
                            updateState = {this.updateState}
                            component={Accounts}
                        />
                        <PrivateRoute
                            path="/campaignGroup/metrics"
                            data = {this.data}
                            updateState = {this.updateState}
                            component={Metrics}
                        />
                        <PrivateRoute
                            path="/campaignGroup/ads"
                            data = {this.data}
                            component={Ads}
                        />
                        <PrivateRoute
                            path="/campaignGroup/budget"
                            data = {this.data}
                            component={Budget}
                        />
                        <PrivateRoute
                            path="/campaignGroup/publish"
                            data = {this.data}
                            component={Publish}
                        />
                    </div>
                </div>
            </div>
        </div>
        )
    }
} 

export default CampaignHome